import { render } from "./rightTips.vue?vue&type=template&id=7615f30c&scoped=true&ts=true"
import script from "./rightTips.vue?vue&type=script&lang=ts"
export * from "./rightTips.vue?vue&type=script&lang=ts"

import "./rightTips.vue?vue&type=style&index=0&id=7615f30c&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7615f30c"]])

export default __exports__